import { SofaSingleOutlineIcon } from './SofaSingleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C4595FA1-E495-4BFE-900A-A1D764B6019E
 * name sofa-single-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sofa-single-outline.svg
 * tags
 * - Home Automation 
 */
export const LoveseatOutlineIcon = SofaSingleOutlineIcon;
export default LoveseatOutlineIcon